<section class="warengruppen-list">
    @if (isLoading) {
    @for (group of skeletonGroups; track $index) {
    <article class="warengruppe-card warengruppe-card-skeleton">
        <header class="warengruppe-header">
            <span class="skeleton skeleton-text skeleton-text-strong"></span>
            <span class="skeleton skeleton-text skeleton-text-medium"></span>
        </header>

        <table class="warengruppen-table-skeleton">
            <thead>
                <tr>
                    <th>ART.NR</th>
                    <th>NAME</th>
                    <th>PREIS / €</th>
                    <th>VORSCHLAG</th>
                    <th>BESTELLMENGE</th>
                    <th>EINHEIT / LOS</th>
                    <th>½ PKG.</th>
                    <th>MIN</th>
                    <th>MAX</th>
                </tr>
            </thead>

            <tbody>
                @for (row of skeletonRows; track $index) {
                <tr>
                    <td>
                        <span class="skeleton skeleton-text skeleton-text-small"></span>
                    </td>

                    <td>
                        <span class="skeleton skeleton-text skeleton-text-strong"></span>
                    </td>

                    <td>
                        <span class="skeleton skeleton-text skeleton-text-small"></span>
                    </td>

                    <td>
                        <span class="skeleton skeleton-text skeleton-text-small"></span>
                    </td>

                    <td>
                        <span class="skeleton skeleton-quantity"></span>
                    </td>

                    <td>
                        <span class="skeleton skeleton-text skeleton-text-medium"></span>
                    </td>

                    <td>
                        <span class="skeleton skeleton-checkbox"></span>
                    </td>

                    <td>
                        <span class="skeleton skeleton-text skeleton-text-small"></span>
                    </td>

                    <td>
                        <span class="skeleton skeleton-text skeleton-text-small"></span>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </article>
    }
    } @else if (warengruppen().length === 0) {
    <div class="empty-warengruppen-state">
        <mat-icon fontSet="material-icons-outlined">search_off</mat-icon>
        <span>Keine Warengruppe gefunden.</span>
    </div>
    } @else {
    @for (warengruppe of warengruppen(); track warengruppe.name) {
    <article class="warengruppe-card">
        <header class="warengruppe-header">
            <strong>{{ warengruppe.name }}</strong>
            <span>
                {{ warengruppe.artikelCount }} Artikel · {{ warengruppe.total }}
            </span>
        </header>

        <table>
            <thead>
                <tr>
                    <th>
                        <button type="button" class="sort-header" [class.sort-header-active]="isSortActive('nummer')"
                            (click)="setSort('nummer')">
                            <span>ART.NR</span>
                            <mat-icon fontSet="material-icons-outlined">
                                {{ getSortIcon('nummer') }}
                            </mat-icon>
                        </button>
                    </th>

                    <th>
                        <button type="button" class="sort-header" [class.sort-header-active]="isSortActive('name')"
                            (click)="setSort('name')">
                            <span>NAME</span>
                            <mat-icon fontSet="material-icons-outlined">
                                {{ getSortIcon('name') }}
                            </mat-icon>
                        </button>
                    </th>

                    <th>
                        <button type="button" class="sort-header" [class.sort-header-active]="isSortActive('preis')"
                            (click)="setSort('preis')">
                            <span>PREIS / €</span>
                            <mat-icon fontSet="material-icons-outlined">
                                {{ getSortIcon('preis') }}
                            </mat-icon>
                        </button>
                    </th>

                    <th>
                        <button type="button" class="sort-header" [class.sort-header-active]="isSortActive('vorschlag')"
                            (click)="setSort('vorschlag')">
                            <span>VORSCHLAG</span>
                            <mat-icon fontSet="material-icons-outlined">
                                {{ getSortIcon('vorschlag') }}
                            </mat-icon>
                        </button>
                    </th>

                    <th>
                        <button type="button" class="sort-header" [class.sort-header-active]="isSortActive('menge')"
                            (click)="setSort('menge')">
                            <span>BESTELLMENGE</span>
                            <mat-icon fontSet="material-icons-outlined">
                                {{ getSortIcon('menge') }}
                            </mat-icon>
                        </button>
                    </th>

                    <th>
                        <button type="button" class="sort-header" [class.sort-header-active]="isSortActive('einheit')"
                            (click)="setSort('einheit')">
                            <span>EINHEIT / LOS</span>
                            <mat-icon fontSet="material-icons-outlined">
                                {{ getSortIcon('einheit') }}
                            </mat-icon>
                        </button>
                    </th>

                    <th>
                        <button type="button" class="sort-header" [class.sort-header-active]="isSortActive('pkg')"
                            (click)="setSort('pkg')">
                            <span>½ PKG.</span>
                            <mat-icon fontSet="material-icons-outlined">
                                {{ getSortIcon('pkg') }}
                            </mat-icon>
                        </button>
                    </th>

                    <th>
                        <button type="button" class="sort-header" [class.sort-header-active]="isSortActive('min')"
                            (click)="setSort('min')">
                            <span>MIN</span>
                            <mat-icon fontSet="material-icons-outlined">
                                {{ getSortIcon('min') }}
                            </mat-icon>
                        </button>
                    </th>

                    <th>
                        <button type="button" class="sort-header" [class.sort-header-active]="isSortActive('max')"
                            (click)="setSort('max')">
                            <span>MAX</span>
                            <mat-icon fontSet="material-icons-outlined">
                                {{ getSortIcon('max') }}
                            </mat-icon>
                        </button>
                    </th>
                </tr>
            </thead>

            <tbody>
                @for (item of warengruppe.artikel; track item.nummer) {
                <tr class="article-row" [class.article-row-selected]="activeArtikelNumber === item.nummer"
                    [class.article-row-invalid]="isEditMode && item.changed && getMengeError(item)"
                    (click)="artikelSelected.emit(item.nummer)">

                    <td>{{ item.nummer }}</td>

                    <td>
                        <div class="article-name">
                            <strong>{{ item.name }}</strong>

                            @if (isEditMode && item.changed && getMengeError(item)) {
                            <span class="quantity-error">
                                <mat-icon fontSet="material-icons-outlined">
                                    warning
                                </mat-icon>
                                {{ getMengeError(item) }}
                            </span>
                            }
                        </div>
                    </td>

                    <td>{{ item.preis }}</td>

                    <td>{{ item.vorschlag }}</td>

                    <td>
                        <div class="quantity-cell-content">

                            @if (isEditMode) {

                            <div class="quantity-editor">

                                <button type="button" class="quantity-button" [disabled]="item.readonly"
                                    (click)="mengeDecreased.emit(item.nummer); $event.stopPropagation()">

                                    <mat-icon fontSet="material-icons-outlined">
                                        remove
                                    </mat-icon>

                                </button>

                                <div class="quantity-input-stack">

                                    <input type="number" class="quantity-input"
                                        [value]="item.changed || item.saved ? (item.menge ?? '') : ''"
                                        [placeholder]="(item.menge ?? item.vorschlag).toString()"
                                        [attr.min]="getInputMin(item)" [attr.max]="getInputMax(item)"
                                        [attr.step]="getQuantityInputStep(item)" [disabled]="item.readonly"
                                        (click)="$event.stopPropagation()" (input)="onMengeInput(item.nummer, $event)"
                                        (keydown.enter)="quantityEnterPressed.emit($event)" />

                                    @if (getQuantityCalculationLabel(item); as calculationLabel) {
                                    <small class="quantity-calculation">
                                        {{ calculationLabel }}
                                    </small>
                                    }

                                </div>

                                <button type="button" class="quantity-button" [disabled]="item.readonly"
                                    (click)="mengeIncreased.emit(item.nummer); $event.stopPropagation()">

                                    <mat-icon fontSet="material-icons-outlined">
                                        add
                                    </mat-icon>

                                </button>

                            </div>

                            } @else {

                            @if (item.menge !== null) {

                            <span class="quantity-badge"
                                [class.quantity-badge-placeholder]="!item.changed && !item.saved">

                                {{ item.menge }}

                            </span>

                            } @else {

                            <span class="quantity-placeholder">
                                —
                            </span>

                            }

                            }

                        </div>
                    </td>

                    <td>{{ item.einheit }}</td>

                    <td>
                        @if (item.pkg) {

                        <span class="pkg-check" aria-label="Halbe Packung">
                            ✓
                        </span>

                        } @else {

                        <span class="muted-value">
                            —
                        </span>

                        }
                    </td>

                    <td>
                        @if (item.min !== null) {
                        {{ item.min }}
                        } @else {
                        <span class="muted-value">—</span>
                        }
                    </td>

                    <td>
                        @if (item.max !== null) {
                        {{ item.max }}
                        } @else {
                        <span class="muted-value">—</span>
                        }
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </article>
    }
    }
</section>